// Public UI adapted from Klargo-Reference/content/legal/termsOfUse.ts.
//
// Bilingual: Klargo-Reference only ships Swedish legal copy — there was no
// existing English version anywhere in either codebase. EN below is a
// translation authored for this app rather than a legally reviewed
// official text; it should be checked against Klargo's authoritative
// Swedish terms before being relied on for a real dispute.
const SV = {
  title: 'Användarvillkor för Klargo',
  effective: 'Gäller från: 18 juli 2026',
  updated: 'Senast uppdaterade: 18 juli 2026',
  intro: [
    { kind: 'paragraph', text: 'Dessa användarvillkor gäller mellan dig och:' },
    { kind: 'paragraph', text: 'Klargo Technologies AB' },
    { kind: 'paragraph', text: 'Organisationsnummer: 559571-7736' },
    { kind: 'paragraph', text: 'E-post: info@klargo.se' },
    { kind: 'paragraph', text: 'Webbplats: klargo.se' },
  ],
  blocks: [
    { kind: 'section', text: '1. Om Klargo och villkoren' },
    { kind: 'paragraph', text: 'Klargo är en digital webbapp som hjälper privatpersoner att genomföra en fordonsaffär på ett mer strukturerat och tryggt sätt.' },
    { kind: 'paragraph', text: 'Genom Klargo kan köpare och säljare bland annat:' },
    {
      kind: 'list',
      items: [
        'identifiera sig med BankID',
        'ansluta till samma affär',
        'hämta och granska fordonsuppgifter',
        'dokumentera vad parterna har kommit överens om',
        'skapa och signera ett köpekontrakt',
        'genomföra affärens olika steg i en tydlig ordning',
        'få stöd inför betalning och ägarbyte',
        'spara det slutliga kontraktet och tillhörande dokument',
      ],
    },
    { kind: 'paragraph', text: 'Klargos webbapp och tillhörande funktioner kallas i dessa villkor för Tjänsten.' },
    { kind: 'paragraph', text: 'Villkoren reglerar ditt avtal med Klargo om användningen av Tjänsten. De reglerar inte själva köpet av fordonet.' },
    { kind: 'paragraph', text: 'Fordonsköpet är ett separat avtal direkt mellan köparen och säljaren. För det avtalet gäller det köpekontrakt som parterna ingår och tillämplig lag.' },
    { kind: 'section', text: '2. Godkännande och avtalsinformation' },
    { kind: 'paragraph', text: 'Du accepterar dessa villkor aktivt när du skapar ett konto eller innan du börjar använda en funktion som kräver ett avtal med Klargo.' },
    { kind: 'paragraph', text: 'Klargo registrerar vilken villkorsversion du har accepterat samt datum och tid för godkännandet.' },
    { kind: 'paragraph', text: 'Avtal med Klargo ingås på svenska. Villkoren görs tillgängliga så att du kan spara och läsa dem i efterhand.' },
    { kind: 'paragraph', text: 'Om du beställer en avgiftsbelagd Klargotjänst får du före beställningen tydlig information om:' },
    {
      kind: 'list',
      items: [
        'vad tjänsten omfattar',
        'total avgift inklusive moms',
        'vem som ska betala avgiften',
        'när avgiften tas ut',
        'när tjänsten anses levererad',
        'eventuell ångerrätt',
      ],
    },
    { kind: 'paragraph', text: 'Du får en elektronisk bekräftelse efter en avgiftsbelagd beställning.' },
    { kind: 'paragraph', text: 'Särskild information om innehåll, pris eller leverans som visas inför en viss beställning gäller för den beställningen. Om informationen avviker från dessa allmänna villkor gäller den särskilda informationen, förutsatt att den inte begränsar dina rättigheter enligt tvingande lag.' },
    { kind: 'section', text: '3. Vem som får använda Klargo' },
    { kind: 'paragraph', text: 'För att använda Klargo måste du:' },
    {
      kind: 'list',
      items: [
        'vara minst 18 år',
        'vara privatperson',
        'agera i eget namn och för egen räkning',
        'använda Tjänsten huvudsakligen för privat bruk',
        'ha rätt att ingå de avtal som du genomför',
        'lämna korrekta, aktuella och fullständiga uppgifter',
      ],
    },
    { kind: 'paragraph', text: 'Tjänsten är inte avsedd för yrkesmässig bilhandel eller för användare som säljer eller köper fordon inom näringsverksamhet.' },
    { kind: 'paragraph', text: 'Säljaren ska bekräfta om försäljningen sker som privatperson. Uppgiften visas för köparen före signering.' },
    { kind: 'paragraph', text: 'Om en säljare i verkligheten agerar som näringsidkare avgörs detta av omständigheterna och tillämplig lag. Att säljaren väljer eller bekräftar ett privatflöde tar inte bort rättigheter som köparen kan ha enligt tvingande konsumentlagstiftning.' },
    { kind: 'paragraph', text: 'När både köparen och säljaren agerar som privatpersoner gäller inte konsumentköplagen eller den lagstadgade ångerrätten för själva fordonsköpet. Parternas köpekontrakt gäller i första hand och köplagen gäller i den mån parterna inte har avtalat om något annat.' },
    { kind: 'section', text: '4. Konto, BankID och tekniska krav' },
    { kind: 'paragraph', text: 'Du kan skapa ett konto med e-postadress eller BankID.' },
    { kind: 'paragraph', text: 'Giltigt BankID krävs för att:' },
    {
      kind: 'list',
      items: [
        'starta en köp- eller säljprocess',
        'ansluta till en fordonsaffär',
        'verifiera din identitet',
        'signera ett köpekontrakt',
      ],
    },
    { kind: 'paragraph', text: 'Ditt konto är personligt och får inte delas med någon annan.' },
    { kind: 'paragraph', text: 'Du ansvarar för att:' },
    {
      kind: 'list',
      items: [
        'skydda dina inloggningsuppgifter och ditt BankID',
        'inte låta någon annan använda ditt konto',
        'inte låta någon annan identifiera sig eller signera i ditt namn',
        'snarast kontakta Klargo vid misstanke om obehörig användning',
      ],
    },
    { kind: 'paragraph', text: 'Du ansvarar inte automatiskt för obehörig användning som beror på en säkerhetsbrist i Klargos system eller ett annat förhållande som Klargo ansvarar för.' },
    { kind: 'paragraph', text: 'För att använda Tjänsten behöver du en fungerande internetanslutning, en webbläsare som stöds och, för affärsflödet, tillgång till BankID. Klargo kan informera om ytterligare tekniska krav direkt i Tjänsten.' },
    { kind: 'section', text: '5. Hur en affär fungerar i Klargo' },
    { kind: 'paragraph', text: 'Klargo är inte en annonsplats och visar eller rangordnar inte fordonsannonser. Tjänsten används för en specifik fordonsaffär som köparen och säljaren själva har tagit initiativ till.' },
    { kind: 'paragraph', text: 'Säljaren startar en affär för ett bestämt fordon. Köparen ansluter därefter till samma affär genom den anslutningsmetod som Tjänsten tillhandahåller, exempelvis en länk, QR-kod eller annan identifiering av affären.' },
    { kind: 'paragraph', text: 'När parterna har anslutit kan de:' },
    {
      kind: 'list',
      items: [
        'bekräfta sina identiteter',
        'granska fordonsuppgifter',
        'ange pris och övriga avtalsuppgifter',
        'kontrollera den information som ska ingå i kontraktet',
        'signera samma slutliga kontraktsversion',
      ],
    },
    { kind: 'paragraph', text: 'Varje part ansvarar för de uppgifter som parten själv lämnar eller bekräftar.' },
    { kind: 'paragraph', text: 'En påbörjad process i Klargo innebär inte i sig att ett fordonsköp har genomförts. Klargo avgör inte heller om parterna genom kontakter utanför Tjänsten redan har ingått ett bindande avtal.' },
    { kind: 'section', text: '6. Klargos roll' },
    { kind: 'paragraph', text: 'Klargo tillhandahåller den digitala strukturen runt affären.' },
    { kind: 'paragraph', text: 'Tjänsten är utformad för att minska osäkerhet och vanliga risker genom:' },
    {
      kind: 'list',
      items: [
        'säker identifiering',
        'ett gemensamt och strukturerat affärsflöde',
        'tydlig dokumentation',
        'versionshantering',
        'elektronisk signering',
        'tillgång till slutliga dokument',
      ],
    },
    { kind: 'paragraph', text: 'Klargo:' },
    {
      kind: 'list',
      items: [
        'köper inte fordon',
        'säljer inte fordon',
        'äger inte fordon',
        'bestämmer inte priset',
        'värderar inte fordonet',
        'företräder inte köparen eller säljaren',
        'är inte part i köpekontraktet',
        'tar inte emot eller förvarar köpeskillingen',
        'garanterar inte att en part fullgör sina skyldigheter',
      ],
    },
    { kind: 'paragraph', text: 'Klargo gör affären mer strukturerad och tryggare att genomföra, men kan inte undanröja alla risker i en affär mellan två privatpersoner.' },
    { kind: 'paragraph', text: 'Klargo ansvarar för att tillhandahålla den egna Tjänsten enligt avtalet och tillämplig tvingande lag.' },
    { kind: 'section', text: '7. Köparens och säljarens ansvar' },
    { kind: 'subheading', text: 'Säljaren ansvarar för att' },
    {
      kind: 'list',
      items: [
        'ha rätt att sälja fordonet',
        'lämna korrekta och fullständiga uppgifter',
        'informera om kända fel, skador och betydelsefulla omständigheter',
        'inte undanhålla kända skulder, belastningar eller andra förhållanden som påverkar fordonet',
        'kontrollera pris, betalningsvillkor, överlämnande och övriga kontraktsuppgifter',
        'granska den slutliga kontraktsversionen före signering',
      ],
    },
    { kind: 'subheading', text: 'Köparen ansvarar för att' },
    {
      kind: 'list',
      items: [
        'kontrollera fordonet före köpet',
        'bedöma behovet av provkörning, besiktning eller annan undersökning',
        'kontrollera fordonets skick och de uppgifter som säljaren lämnat',
        'kontrollera pris och övriga avtalsvillkor',
        'säkerställa att betalningen görs till rätt mottagare',
        'granska den slutliga kontraktsversionen före signering',
      ],
    },
    { kind: 'paragraph', text: 'Klargos fordonsuppgifter, kontroller och digitala flöde ersätter inte parternas eget ansvar för att bedöma fordonet och affären.' },
    { kind: 'section', text: '8. Fordonsuppgifter' },
    { kind: 'paragraph', text: 'Klargo kan hämta fordonsinformation från externa datakällor när köparen och säljaren har anslutit till en faktisk affär.' },
    { kind: 'paragraph', text: 'Informationen kan exempelvis omfatta:' },
    {
      kind: 'list',
      items: [
        'registreringsnummer',
        'märke och modell',
        'årsmodell',
        'VIN',
        'tekniska fordonsuppgifter',
        'annan information som är relevant för affären',
      ],
    },
    { kind: 'paragraph', text: 'Klargo strävar efter att återge informationen korrekt men kan inte garantera att externa register alltid är fullständiga, korrekta eller uppdaterade.' },
    { kind: 'paragraph', text: 'Parterna ska kontrollera uppgifter som är viktiga för affären före signering, betalning och överlämnande.' },
    { kind: 'paragraph', text: 'Om Klargo får kännedom om ett fel i den egna presentationen av informationen ska Klargo, när det är möjligt, rätta felet.' },
    { kind: 'paragraph', text: 'Klargo ansvarar inte för ett fel som finns i en extern datakälla och som Klargo inte skäligen har kunnat upptäcka. Klargo ansvarar däremot för fel som uppstår genom Klargos egen behandling eller presentation av informationen i den utsträckning som följer av avtalet och tvingande lag.' },
    { kind: 'section', text: '9. Köpekontrakt och signering' },
    { kind: 'paragraph', text: 'Klargo skapar ett köpekontrakt utifrån de uppgifter som köparen och säljaren lämnar eller bekräftar.' },
    { kind: 'paragraph', text: 'Båda parterna ansvarar för att granska hela kontraktet innan det signeras.' },
    { kind: 'paragraph', text: 'Varje BankID-underskrift kopplas till:' },
    {
      kind: 'list',
      items: [
        'den person som skriver under',
        'datum och tid',
        'den kontraktsversion som visas vid signeringen',
      ],
    },
    { kind: 'paragraph', text: 'Om en betydelsefull uppgift ändras efter att en eller båda parter har signerat gäller inte de tidigare underskrifterna för den ändrade versionen.' },
    { kind: 'paragraph', text: 'Klargo skapar då en ny kontraktsversion. Den nya versionen måste granskas och signeras av båda parter.' },
    { kind: 'paragraph', text: 'Betydelsefulla ändringar kan exempelvis avse:' },
    {
      kind: 'list',
      items: [
        'köparens eller säljarens identitet',
        'fordonets identitet',
        'pris',
        'betalningsvillkor',
        'överlämnande',
        'kända fel eller skador',
        'andra centrala avtalsvillkor',
      ],
    },
    { kind: 'paragraph', text: 'Det slutliga signerade kontraktet görs tillgängligt för båda parter i ett format som kan sparas.' },
    { kind: 'paragraph', text: 'Klargo lämnar inte individuell juridisk rådgivning och avgör inte vilka särskilda avtalsvillkor parterna bör komma överens om.' },
    { kind: 'section', text: '10. Betalningen mellan köparen och säljaren' },
    { kind: 'paragraph', text: 'Köpeskillingen betalas direkt från köparen till säljaren med den betalningsmetod som parterna väljer.' },
    { kind: 'paragraph', text: 'Klargo:' },
    {
      kind: 'list',
      items: [
        'tar aldrig emot köpeskillingen',
        'håller aldrig köpeskillingen för någon av parterna',
        'kan inte disponera pengarna',
        'erbjuder inte ett eget klientmedels- eller escrowkonto',
        'avgör inte vem som har rätt till pengarna vid en tvist',
      ],
    },
    { kind: 'paragraph', text: 'Klargo kan guida parterna genom betalningssteget och registrera information eller bekräftelser som parterna lämnar.' },
    { kind: 'paragraph', text: 'Om Tjänsten visar att en betalning har initierats, bekräftats eller markerats som genomförd innebär detta inte en självständig garanti från Klargo om att pengarna är slutligt mottagna eller inte kan återkallas.' },
    { kind: 'paragraph', text: 'Köparen och säljaren ska själva kontrollera den faktiska betalningen i den bank eller betalningstjänst som används innan fordon, nycklar, registreringshandlingar eller besittning överlämnas.' },
    { kind: 'paragraph', text: 'Klargos eventuella egen avgift är separat från köpeskillingen för fordonet. En sådan avgift kan betalas till Klargo, men Klargo tar aldrig emot själva betalningen för fordonet.' },
    { kind: 'section', text: '11. Klargos avgift' },
    { kind: 'paragraph', text: 'Det framgår i Tjänsten om användningen är kostnadsfri eller om Klargo tar ut en avgift för en viss funktion eller affär.' },
    { kind: 'paragraph', text: 'Om Klargo tar ut en avgift visas före beställningen:' },
    {
      kind: 'list',
      items: [
        'vad användaren köper',
        'vem som ska betala',
        'total avgift inklusive moms',
        'när betalningsskyldigheten uppstår',
        'när avgiften tas ut',
        'när tjänsten anses fullgjord',
      ],
    },
    { kind: 'paragraph', text: 'Om ingen Klargoavgift visas före beställningen är du inte skyldig att betala någon sådan avgift.' },
    { kind: 'paragraph', text: 'Ett avtal om en avgiftsbelagd Klargotjänst ingås först när du aktivt bekräftar en beställning där betalningsskyldigheten framgår tydligt.' },
    { kind: 'paragraph', text: 'Vad som ingår i tjänsten och när den är fullgjord anges i beställningsinformationen. För en normal transaktionstjänst kan fullgörandet exempelvis vara kopplat till att den slutliga kontraktsversionen har signerats och de avtalade dokumenten har gjorts tillgängliga.' },
    { kind: 'paragraph', text: 'Klargo kan ha fullgjort den beställda tjänsten även om köparen eller säljaren därefter inte fullföljer sina skyldigheter enligt fordonsköpet, förutsatt att Klargo har levererat det som ingick i beställningen.' },
    { kind: 'section', text: '12. Stöd vid ägarbyte' },
    { kind: 'paragraph', text: 'Klargo kan guida köparen och säljaren genom de uppgifter och steg som behövs för att anmäla ägarbyte.' },
    { kind: 'paragraph', text: 'Själva ägarbytet genomförs och registreras av Transportstyrelsen, inte av Klargo.' },
    { kind: 'paragraph', text: 'Parterna ansvarar för att:' },
    {
      kind: 'list',
      items: [
        'följa Transportstyrelsens aktuella krav',
        'lämna korrekta uppgifter',
        'genomföra anmälan på ett tillgängligt sätt',
        'kontrollera att anmälan har skickats in',
        'kontrollera att ägarbytet faktiskt har registrerats',
      ],
    },
    { kind: 'paragraph', text: 'En status eller bekräftelse i Klargo innebär inte i sig att Transportstyrelsen har registrerat ägarbytet.' },
    { kind: 'paragraph', text: 'Klargo kan inte garantera att Transportstyrelsens tjänster är tillgängliga eller att ett ägarbyte godkänns och registreras.' },
    { kind: 'section', text: '13. Ångerrätt för Klargos tjänst' },
    { kind: 'paragraph', text: 'Detta avsnitt gäller endast en avgiftsbelagd tjänst som köps av Klargo. Det gäller inte fordonsköpet mellan köparen och säljaren.' },
    { kind: 'paragraph', text: 'När du som konsument köper en Klargotjänst på distans har du som huvudregel 14 dagars ångerrätt från den dag då avtalet ingås.' },
    { kind: 'paragraph', text: 'Om du vill att Klargo ska börja utföra tjänsten innan ångerfristen har löpt ut behöver du uttryckligen begära att tjänsten påbörjas direkt.' },
    { kind: 'paragraph', text: 'Om du ångrar avtalet efter att tjänsten har påbörjats men innan den har fullgjorts kan Klargo, när lagen medger det, ha rätt till en skälig och proportionell ersättning för den del som redan har utförts. Du får information om detta före beställningen.' },
    { kind: 'paragraph', text: 'Ångerrätten upphör när tjänsten har blivit helt fullgjord, under förutsättning att du före beställningen:' },
    {
      kind: 'list',
      items: [
        'uttryckligen har samtyckt till att tjänsten börjar utföras direkt',
        'har bekräftat att du förstår att ångerrätten upphör när tjänsten är fullgjord',
      ],
    },
    { kind: 'paragraph', text: 'När ångerrätt gäller kan du använda den elektroniska ångerfunktionen i Tjänsten. Du får då ett elektroniskt mottagningsbevis.' },
    { kind: 'paragraph', text: 'Du kan också lämna ett annat tydligt meddelande till Klargo eller använda Konsumentverkets standardblankett.' },
    { kind: 'paragraph', text: 'Fordonsköpet sker mellan köparen och säljaren. Någon lagstadgad ångerrätt gäller normalt inte för ett köp mellan två privatpersoner. En sådan rätt finns endast om parterna själva har avtalat om den eller om den följer av annan tillämplig lag.' },
    { kind: 'section', text: '14. Fel och reklamationer' },
    { kind: 'paragraph', text: 'Klargo ansvarar för den egna Tjänsten, inte för själva fordonet eller den andra partens agerande.' },
    { kind: 'paragraph', text: 'Om Klargos Tjänst är felaktig eller inte motsvarar vad som avtalats kan du reklamera till Klargo.' },
    { kind: 'paragraph', text: 'Det kan exempelvis gälla:' },
    {
      kind: 'list',
      items: [
        'fel i Klargos kontraktsflöde',
        'felaktig kontraktsversion',
        'fel i en BankID-koppling som Klargo ansvarar för',
        'dokument som Klargo har åtagit sig att tillhandahålla men inte levererat',
        'felaktig debitering av en Klargoavgift',
        'en avtalad funktion som inte fungerar',
      ],
    },
    { kind: 'paragraph', text: 'Kontakta Klargo och beskriv vad som har blivit fel, när felet inträffade och vilken lösning du önskar.' },
    { kind: 'paragraph', text: 'Klargo ska få möjlighet att undersöka och, när det är möjligt, rätta felet inom skälig tid.' },
    { kind: 'paragraph', text: 'Dina rättigheter vid fel, dröjsmål, prisavdrag, hävning eller ersättning följer av tillämplig tvingande konsumenträtt och begränsas inte av dessa villkor.' },
    { kind: 'paragraph', text: 'Krav eller reklamationer som gäller följande ska riktas till den andra parten i fordonsaffären:' },
    {
      kind: 'list',
      items: [
        'fordonets skick eller funktion',
        'säljarens fordonsuppgifter',
        'köparens betalning',
        'överlämnandet',
        'fel eller avtalsbrott enligt köpekontraktet',
      ],
    },
    { kind: 'paragraph', text: 'Klagomål på Transportstyrelsens eller en banks egen tjänst kan behöva riktas direkt till den aktuella aktören.' },
    { kind: 'section', text: '15. Tillåten användning' },
    { kind: 'paragraph', text: 'Du får endast använda Klargo för lagliga och verkliga fordonsaffärer.' },
    { kind: 'paragraph', text: 'Du får inte:' },
    {
      kind: 'list',
      items: [
        'lämna medvetet felaktiga eller vilseledande uppgifter',
        'utge dig för att vara någon annan',
        'använda någon annans konto eller BankID',
        'använda Tjänsten för bedrägeri, penningtvätt eller annan brottslighet',
        'försöka kringgå säkerhetsfunktioner',
        'manipulera, störa eller överbelasta Tjänsten',
        'föra in skadlig kod',
        'automatiskt massinsamla information utan Klargos tillstånd',
        'använda Tjänsten för spam eller oönskad marknadsföring',
      ],
    },
    { kind: 'section', text: '16. Begränsning och avslut av konto' },
    { kind: 'paragraph', text: 'Klargo kan tillfälligt begränsa ett konto eller en affär om det finns rimliga skäl att misstänka:' },
    {
      kind: 'list',
      items: [
        'obehörig användning',
        'bedrägeri eller annan brottslighet',
        'allvarligt brott mot villkoren',
        'risk för en användare',
        'risk för Klargo eller Tjänstens säkerhet',
      ],
    },
    { kind: 'paragraph', text: 'Åtgärden ska vara proportionerlig till risken.' },
    { kind: 'paragraph', text: 'Klargo ska, när det kan ske utan att äventyra säkerhet, utredning eller lagkrav, informera användaren om åtgärden och hur den kan begäras omprövad.' },
    { kind: 'paragraph', text: 'Klargo ska ta rimlig hänsyn till pågående affärer och användarens tillgång till redan signerade kontrakt och dokument.' },
    { kind: 'paragraph', text: 'Du kan avsluta ditt konto genom Tjänsten eller genom att kontakta Klargo.' },
    { kind: 'paragraph', text: 'Ett kontoavslut påverkar inte:' },
    {
      kind: 'list',
      items: [
        'redan ingångna avtal',
        'signerade köpekontrakt',
        'uppkomna betalningsskyldigheter',
        'pågående reklamationer eller tvister',
        'uppgifter som måste bevaras enligt lag eller för rättsliga anspråk',
      ],
    },
    { kind: 'section', text: '17. Tillgänglighet och ändringar' },
    { kind: 'paragraph', text: 'Klargo arbetar för att Tjänsten ska vara säker och tillgänglig, men kan inte garantera att den alltid fungerar utan avbrott.' },
    { kind: 'paragraph', text: 'Tillfälliga avbrott kan förekomma på grund av:' },
    {
      kind: 'list',
      items: [
        'underhåll',
        'uppdateringar',
        'säkerhetsåtgärder',
        'tekniska fel',
        'störningar hos externa tjänster',
        'omständigheter utanför Klargos rimliga kontroll',
      ],
    },
    { kind: 'paragraph', text: 'Klargo får göra ändringar som behövs för säkerhet, lagkrav, teknisk funktion eller fortsatt utveckling.' },
    { kind: 'paragraph', text: 'En pågående avgiftsbelagd beställning ska som huvudregel omfattas av den tjänst, det pris och de villkor som gällde när beställningen gjordes.' },
    { kind: 'paragraph', text: 'Om en förändring väsentligt försämrar en redan avtalad digital tjänst gäller användarens rättigheter enligt tvingande konsumenträtt.' },
    { kind: 'section', text: '18. Klargos ansvar' },
    { kind: 'paragraph', text: 'Klargo ansvarar för den egna Tjänsten enligt avtalet och tillämplig tvingande lag.' },
    { kind: 'paragraph', text: 'Klargo ansvarar inte för:' },
    {
      kind: 'list',
      items: [
        'fordonets skick, värde, funktion eller lämplighet',
        'en användares felaktiga eller ofullständiga uppgifter',
        'att en part inte betalar, överlämnar fordonet eller fullgör köpekontraktet',
        'tvister mellan köparen och säljaren',
        'beslut som fattas av Transportstyrelsen, banker eller andra självständiga aktörer',
        'fel i externa register som Klargo inte skäligen har kunnat upptäcka',
        'omständigheter utanför Klargos rimliga kontroll',
      ],
    },
    { kind: 'paragraph', text: 'Klargo kan inte garantera att Tjänsten förhindrar alla bedrägerier, misstag eller avtalsbrott.' },
    { kind: 'paragraph', text: 'En extern leverantörs medverkan befriar inte Klargo från ansvar för en del av den egna Tjänsten som Klargo har åtagit sig att leverera.' },
    { kind: 'paragraph', text: 'Ingenting i villkoren begränsar ett ansvar eller en rättighet som inte får begränsas enligt tvingande lag.' },
    { kind: 'section', text: '19. Tvister mellan köpare och säljare' },
    { kind: 'paragraph', text: 'Tvister om fordonet, priset, betalningen, skicket, överlämnandet, ägarbytet eller köpekontraktet ska lösas mellan köparen och säljaren.' },
    { kind: 'paragraph', text: 'Klargo är inte skyldigt att:' },
    {
      kind: 'list',
      items: [
        'medla mellan parterna',
        'avgöra vem som har rätt',
        'driva ett krav för någon av parterna',
        'ersätta en part för den andra partens avtalsbrott',
      ],
    },
    { kind: 'paragraph', text: 'Klargo kan, när det är tillåtet och lämpligt, göra kontrakt, tidsstämplar, signeringsuppgifter och annan relevant information från Tjänsten tillgängliga för berörd användare eller behörig myndighet.' },
    { kind: 'paragraph', text: 'Generell information från Klargo är inte individuell juridisk rådgivning och innebär inte att Klargo tar ställning för någon av parterna.' },
    { kind: 'section', text: '20. Immaterialrätt, personuppgifter och cookies' },
    { kind: 'paragraph', text: 'Klargo och Klargos licensgivare äger rättigheterna till Tjänstens programvara, design, varumärken, texter och övriga innehåll.' },
    { kind: 'paragraph', text: 'Du får en personlig, begränsad och icke överlåtbar rätt att använda Tjänsten enligt dessa villkor.' },
    { kind: 'paragraph', text: 'Du får inte kopiera, sälja, licensiera, ändra eller försöka återskapa Tjänstens programvara annat än när det är tillåtet enligt lag.' },
    { kind: 'paragraph', text: 'Detta begränsar inte din rätt att ladda ned och bevara dina egna kontrakt, kvitton och affärsdokument.' },
    { kind: 'paragraph', text: 'Klargo behandlar personuppgifter enligt Klargos integritetspolicy. Information om cookies och möjlighet att hantera samtycken finns i Klargos cookieinställningar.' },
    { kind: 'section', text: '21. Ändringar av villkoren' },
    { kind: 'paragraph', text: 'Klargo kan uppdatera villkoren när det finns sakliga skäl, exempelvis:' },
    {
      kind: 'list',
      items: [
        'ändrad lagstiftning',
        'säkerhetskrav',
        'nya eller förändrade funktioner',
        'tekniska förändringar',
        'behov av tydligare formuleringar',
      ],
    },
    { kind: 'paragraph', text: 'Vid väsentliga ändringar informerar Klargo i förväg genom Tjänsten eller via e-post.' },
    { kind: 'paragraph', text: 'En redan beställd avgiftsbelagd tjänst eller pågående fordonsaffär påverkas normalt inte av senare villkorsändringar.' },
    { kind: 'paragraph', text: 'Klargo kan kräva att du aktivt accepterar nya villkor innan du startar en ny affär eller använder en ny funktion.' },
    { kind: 'paragraph', text: 'En vanlig inloggning innebär inte automatiskt att du accepterar väsentligt förändrade villkor.' },
    { kind: 'section', text: '22. Lagval och tvistlösning' },
    { kind: 'paragraph', text: 'Svensk lag gäller för dessa villkor, utan att det begränsar rättigheter som följer av tvingande konsumentlagstiftning.' },
    { kind: 'paragraph', text: 'Klagomål om Klargos egen Tjänst ska i första hand riktas till Klargo så att vi får möjlighet att undersöka och hantera frågan.' },
    { kind: 'paragraph', text: 'Om du och Klargo inte kan komma överens kan en tvist om Klargos egen Tjänst prövas av svensk allmän domstol.' },
    { kind: 'paragraph', text: 'Som konsument kan du även ha rätt att anmäla tvisten till Allmänna reklamationsnämnden, ARN, om nämndens villkor är uppfyllda.' },
    { kind: 'paragraph', text: 'ARN prövar tvister mellan konsumenter och företag. En tvist mellan köparen och säljaren om själva fordonet är en tvist mellan två privatpersoner och är inte en konsumenttvist mot Klargo.' },
    { kind: 'section', text: '23. Kontakt' },
    { kind: 'paragraph', text: 'Frågor, klagomål och reklamationer som gäller Klargos egen Tjänst kan lämnas till:' },
    { kind: 'paragraph', text: 'Klargo Technologies AB' },
    { kind: 'paragraph', text: 'Organisationsnummer: 559571-7736' },
    { kind: 'paragraph', text: 'E-post: info@klargo.se' },
    { kind: 'paragraph', text: 'När ångerrätt gäller för en avgiftsbelagd Klargotjänst kan du använda ångerfunktionen i Tjänsten eller lämna ett annat tydligt meddelande till Klargo.' },
    { kind: 'paragraph', text: 'Krav som gäller fordonet, betalningen mellan köparen och säljaren eller någon parts skyldigheter enligt köpekontraktet ska riktas till den andra parten i fordonsaffären.' },
  ],
};

const EN = {
  title: 'Terms of Service for Klargo',
  effective: 'Effective from: 18 July 2026',
  updated: 'Last updated: 18 July 2026',
  intro: [
    { kind: 'paragraph', text: 'These Terms of Service apply between you and:' },
    { kind: 'paragraph', text: 'Klargo Technologies AB' },
    { kind: 'paragraph', text: 'Company registration number: 559571-7736' },
    { kind: 'paragraph', text: 'Email: info@klargo.se' },
    { kind: 'paragraph', text: 'Website: klargo.se' },
  ],
  blocks: [
    { kind: 'section', text: '1. About Klargo and these terms' },
    { kind: 'paragraph', text: 'Klargo is a digital web app that helps private individuals carry out a vehicle deal in a more structured and secure way.' },
    { kind: 'paragraph', text: 'Through Klargo, buyers and sellers can, among other things:' },
    {
      kind: 'list',
      items: [
        'verify their identity with BankID',
        'connect to the same deal',
        'retrieve and review vehicle information',
        'document what the parties have agreed',
        'create and sign a purchase contract',
        "carry out the deal's steps in a clear order",
        'get support ahead of payment and the ownership transfer',
        'save the final contract and related documents',
      ],
    },
    { kind: 'paragraph', text: "Klargo's web app and its related features are referred to in these terms as the Service." },
    { kind: 'paragraph', text: 'These terms govern your agreement with Klargo regarding use of the Service. They do not govern the vehicle purchase itself.' },
    { kind: 'paragraph', text: 'The vehicle purchase is a separate agreement directly between the buyer and the seller. That agreement is governed by the purchase contract the parties enter into and applicable law.' },
    { kind: 'section', text: '2. Acceptance and contract information' },
    { kind: 'paragraph', text: 'You actively accept these terms when you create an account, or before you start using a feature that requires an agreement with Klargo.' },
    { kind: 'paragraph', text: 'Klargo records which version of the terms you have accepted, along with the date and time of acceptance.' },
    { kind: 'paragraph', text: 'Agreements with Klargo are entered into in Swedish. The terms are made available so you can save and read them afterwards.' },
    { kind: 'paragraph', text: 'If you order a paid Klargo service, you will receive clear information before ordering about:' },
    {
      kind: 'list',
      items: [
        'what the service includes',
        'the total fee including VAT',
        'who is required to pay the fee',
        'when the fee is charged',
        'when the service is considered delivered',
        'any right of withdrawal',
      ],
    },
    { kind: 'paragraph', text: 'You will receive an electronic confirmation after a paid order.' },
    { kind: 'paragraph', text: 'Specific information about content, price or delivery shown ahead of a particular order applies to that order. If that information differs from these general terms, the specific information applies, provided it does not limit your rights under mandatory law.' },
    { kind: 'section', text: '3. Who may use Klargo' },
    { kind: 'paragraph', text: 'To use Klargo you must:' },
    {
      kind: 'list',
      items: [
        'be at least 18 years old',
        'be a private individual',
        'act in your own name and on your own behalf',
        'use the Service mainly for private purposes',
        'have the right to enter into the agreements you carry out',
        'provide accurate, current and complete information',
      ],
    },
    { kind: 'paragraph', text: 'The Service is not intended for professional vehicle trading or for users who sell or buy vehicles as part of a business.' },
    { kind: 'paragraph', text: 'The seller must confirm that the sale is made as a private individual. This information is shown to the buyer before signing.' },
    { kind: 'paragraph', text: "Whether a seller is, in reality, acting as a trader is determined by the circumstances and applicable law. A seller choosing or confirming a private-sale flow does not remove any rights the buyer may have under mandatory consumer legislation." },
    { kind: 'paragraph', text: "When both the buyer and the seller act as private individuals, the Swedish Consumer Sales Act and the statutory right of withdrawal do not apply to the vehicle purchase itself. The parties' purchase contract takes precedence, and the Swedish Sale of Goods Act applies to the extent the parties have not agreed otherwise." },
    { kind: 'section', text: '4. Account, BankID and technical requirements' },
    { kind: 'paragraph', text: 'You can create an account using an email address or BankID.' },
    { kind: 'paragraph', text: 'A valid BankID is required to:' },
    {
      kind: 'list',
      items: [
        'start a purchase or sale process',
        'connect to a vehicle deal',
        'verify your identity',
        'sign a purchase contract',
      ],
    },
    { kind: 'paragraph', text: 'Your account is personal and must not be shared with anyone else.' },
    { kind: 'paragraph', text: 'You are responsible for:' },
    {
      kind: 'list',
      items: [
        'protecting your login credentials and your BankID',
        'not letting anyone else use your account',
        'not letting anyone else identify themselves or sign in your name',
        'contacting Klargo promptly if you suspect unauthorized use',
      ],
    },
    { kind: 'paragraph', text: "You are not automatically responsible for unauthorized use resulting from a security flaw in Klargo's systems or another circumstance Klargo is responsible for." },
    { kind: 'paragraph', text: 'To use the Service you need a working internet connection, a supported browser and, for the deal flow, access to BankID. Klargo may provide information about additional technical requirements directly within the Service.' },
    { kind: 'section', text: '5. How a deal works in Klargo' },
    { kind: 'paragraph', text: 'Klargo is not a listings marketplace and does not display or rank vehicle listings. The Service is used for a specific vehicle deal that the buyer and seller have themselves initiated.' },
    { kind: 'paragraph', text: 'The seller starts a deal for a specific vehicle. The buyer then connects to the same deal using the connection method the Service provides, for example a link, a QR code, or another way of identifying the deal.' },
    { kind: 'paragraph', text: 'Once the parties have connected, they can:' },
    {
      kind: 'list',
      items: [
        'confirm their identities',
        'review vehicle information',
        'enter the price and other contract details',
        'check the information to be included in the contract',
        'sign the same final version of the contract',
      ],
    },
    { kind: 'paragraph', text: 'Each party is responsible for the information that party provides or confirms themselves.' },
    { kind: 'paragraph', text: 'A process started in Klargo does not, by itself, mean that a vehicle purchase has been completed. Nor does Klargo determine whether the parties have already entered into a binding agreement through contact outside the Service.' },
    { kind: 'section', text: "6. Klargo's role" },
    { kind: 'paragraph', text: 'Klargo provides the digital structure around the deal.' },
    { kind: 'paragraph', text: 'The Service is designed to reduce uncertainty and common risks through:' },
    {
      kind: 'list',
      items: [
        'secure identification',
        'a shared, structured deal flow',
        'clear documentation',
        'version control',
        'electronic signing',
        'access to the final documents',
      ],
    },
    { kind: 'paragraph', text: 'Klargo:' },
    {
      kind: 'list',
      items: [
        'does not buy vehicles',
        'does not sell vehicles',
        'does not own vehicles',
        'does not set the price',
        'does not value the vehicle',
        'does not represent the buyer or the seller',
        'is not a party to the purchase contract',
        'does not receive or hold the purchase price',
        'does not guarantee that a party fulfils its obligations',
      ],
    },
    { kind: 'paragraph', text: 'Klargo makes the deal more structured and safer to carry out, but cannot eliminate every risk in a deal between two private individuals.' },
    { kind: 'paragraph', text: "Klargo is responsible for providing its own Service in accordance with the agreement and applicable mandatory law." },
    { kind: 'section', text: "7. The buyer's and seller's responsibilities" },
    { kind: 'subheading', text: 'The seller is responsible for' },
    {
      kind: 'list',
      items: [
        'having the right to sell the vehicle',
        'providing accurate and complete information',
        'disclosing known defects, damage and material circumstances',
        'not withholding known debts, encumbrances or other circumstances affecting the vehicle',
        'checking the price, payment terms, handover and other contract details',
        'reviewing the final contract version before signing',
      ],
    },
    { kind: 'subheading', text: 'The buyer is responsible for' },
    {
      kind: 'list',
      items: [
        'inspecting the vehicle before purchase',
        'assessing the need for a test drive, inspection or other examination',
        "checking the vehicle's condition and the information the seller has provided",
        'checking the price and other contract terms',
        'ensuring payment is made to the correct recipient',
        'reviewing the final contract version before signing',
      ],
    },
    { kind: 'paragraph', text: "Klargo's vehicle information, checks and digital flow do not replace the parties' own responsibility to assess the vehicle and the deal." },
    { kind: 'section', text: '8. Vehicle information' },
    { kind: 'paragraph', text: 'Klargo may retrieve vehicle information from external data sources once the buyer and seller have connected to an actual deal.' },
    { kind: 'paragraph', text: 'This information may include, for example:' },
    {
      kind: 'list',
      items: [
        'registration number',
        'make and model',
        'model year',
        'VIN',
        'technical vehicle data',
        'other information relevant to the deal',
      ],
    },
    { kind: 'paragraph', text: 'Klargo aims to present the information accurately but cannot guarantee that external registers are always complete, accurate or up to date.' },
    { kind: 'paragraph', text: 'The parties must check information that is important for the deal before signing, payment and handover.' },
    { kind: 'paragraph', text: "If Klargo becomes aware of an error in its own presentation of the information, Klargo shall, where possible, correct the error." },
    { kind: 'paragraph', text: "Klargo is not responsible for an error that exists in an external data source and that Klargo could not reasonably have detected. Klargo is, however, responsible for errors arising from Klargo's own processing or presentation of the information, to the extent that follows from the agreement and mandatory law." },
    { kind: 'section', text: '9. Purchase contract and signing' },
    { kind: 'paragraph', text: 'Klargo creates a purchase contract based on the information the buyer and seller provide or confirm.' },
    { kind: 'paragraph', text: 'Both parties are responsible for reviewing the entire contract before signing it.' },
    { kind: 'paragraph', text: 'Each BankID signature is linked to:' },
    {
      kind: 'list',
      items: [
        'the person signing',
        'the date and time',
        'the contract version shown at the time of signing',
      ],
    },
    { kind: 'paragraph', text: 'If material information changes after one or both parties have signed, the earlier signatures do not apply to the changed version.' },
    { kind: 'paragraph', text: 'Klargo then creates a new contract version. The new version must be reviewed and signed by both parties.' },
    { kind: 'paragraph', text: 'Material changes may, for example, concern:' },
    {
      kind: 'list',
      items: [
        "the buyer's or seller's identity",
        "the vehicle's identity",
        'price',
        'payment terms',
        'handover',
        'known defects or damage',
        'other key contract terms',
      ],
    },
    { kind: 'paragraph', text: 'The final signed contract is made available to both parties in a format that can be saved.' },
    { kind: 'paragraph', text: 'Klargo does not provide individual legal advice and does not determine which specific contract terms the parties should agree on.' },
    { kind: 'section', text: '10. Payment between the buyer and the seller' },
    { kind: 'paragraph', text: 'The purchase price is paid directly from the buyer to the seller using the payment method the parties choose.' },
    { kind: 'paragraph', text: 'Klargo:' },
    {
      kind: 'list',
      items: [
        'never receives the purchase price',
        'never holds the purchase price on behalf of either party',
        'cannot control or access the funds',
        "does not offer its own client-funds or escrow account",
        'does not decide who is entitled to the funds in a dispute',
      ],
    },
    { kind: 'paragraph', text: 'Klargo may guide the parties through the payment step and record information or confirmations the parties provide.' },
    { kind: 'paragraph', text: 'If the Service shows that a payment has been initiated, confirmed or marked as completed, this does not constitute an independent guarantee from Klargo that the funds have been finally received or cannot be recalled.' },
    { kind: 'paragraph', text: 'The buyer and seller must themselves verify the actual payment in the bank or payment service used before the vehicle, keys, registration documents or possession are handed over.' },
    { kind: 'paragraph', text: "Any fee charged by Klargo itself is separate from the vehicle's purchase price. Such a fee may be paid to Klargo, but Klargo never receives the payment for the vehicle itself." },
    { kind: 'section', text: "11. Klargo's fee" },
    { kind: 'paragraph', text: 'The Service states whether use is free of charge or whether Klargo charges a fee for a particular feature or deal.' },
    { kind: 'paragraph', text: 'If Klargo charges a fee, the following is shown before ordering:' },
    {
      kind: 'list',
      items: [
        'what the user is purchasing',
        'who is required to pay',
        'the total fee including VAT',
        'when the payment obligation arises',
        'when the fee is charged',
        'when the service is considered fulfilled',
      ],
    },
    { kind: 'paragraph', text: 'If no Klargo fee is shown before ordering, you are not obliged to pay any such fee.' },
    { kind: 'paragraph', text: 'An agreement for a paid Klargo service is only entered into once you actively confirm an order in which the payment obligation is clearly stated.' },
    { kind: 'paragraph', text: 'What is included in the service and when it is fulfilled is specified in the order information. For a standard transaction service, fulfilment may, for example, be linked to the final contract version being signed and the agreed documents being made available.' },
    { kind: 'paragraph', text: 'Klargo may have fulfilled the ordered service even if the buyer or seller subsequently fails to fulfil their obligations under the vehicle purchase, provided Klargo has delivered what was included in the order.' },
    { kind: 'section', text: '12. Support with the ownership transfer' },
    { kind: 'paragraph', text: 'Klargo may guide the buyer and seller through the information and steps needed to report the ownership transfer.' },
    { kind: 'paragraph', text: 'The ownership transfer itself is carried out and registered by the Swedish Transport Agency (Transportstyrelsen), not by Klargo.' },
    { kind: 'paragraph', text: 'The parties are responsible for:' },
    {
      kind: 'list',
      items: [
        "following the Swedish Transport Agency's current requirements",
        'providing accurate information',
        'submitting the report through an available method',
        'checking that the report has been submitted',
        'checking that the ownership transfer has actually been registered',
      ],
    },
    { kind: 'paragraph', text: 'A status or confirmation shown in Klargo does not, by itself, mean that the Swedish Transport Agency has registered the ownership transfer.' },
    { kind: 'paragraph', text: "Klargo cannot guarantee that the Swedish Transport Agency's services are available or that an ownership transfer will be approved and registered." },
    { kind: 'section', text: "13. Right of withdrawal for Klargo's service" },
    { kind: 'paragraph', text: 'This section applies only to a paid service purchased from Klargo. It does not apply to the vehicle purchase between the buyer and the seller.' },
    { kind: 'paragraph', text: 'When you, as a consumer, purchase a Klargo service at a distance, you generally have a 14-day right of withdrawal from the day the agreement is entered into.' },
    { kind: 'paragraph', text: 'If you want Klargo to start performing the service before the withdrawal period has expired, you must expressly request that the service begin immediately.' },
    { kind: 'paragraph', text: 'If you withdraw from the agreement after the service has begun but before it has been fulfilled, Klargo may, where the law permits, be entitled to reasonable and proportionate compensation for the part already performed. You will be informed of this before ordering.' },
    { kind: 'paragraph', text: 'The right of withdrawal ends once the service has been fully performed, provided that, before ordering, you:' },
    {
      kind: 'list',
      items: [
        'have expressly consented to the service beginning immediately',
        'have confirmed that you understand the right of withdrawal ends once the service is fully performed',
      ],
    },
    { kind: 'paragraph', text: 'Where the right of withdrawal applies, you can use the electronic withdrawal function in the Service. You will then receive an electronic acknowledgment of receipt.' },
    { kind: 'paragraph', text: "You may also submit another clear statement to Klargo or use the Swedish Consumer Agency's (Konsumentverket) standard withdrawal form." },
    { kind: 'paragraph', text: 'The vehicle purchase takes place between the buyer and the seller. A statutory right of withdrawal normally does not apply to a purchase between two private individuals. Such a right exists only if the parties have agreed to it themselves or if it follows from other applicable law.' },
    { kind: 'section', text: '14. Defects and complaints' },
    { kind: 'paragraph', text: "Klargo is responsible for its own Service, not for the vehicle itself or the other party's conduct." },
    { kind: 'paragraph', text: "If Klargo's Service is defective or does not match what was agreed, you can file a complaint with Klargo." },
    { kind: 'paragraph', text: 'This may, for example, concern:' },
    {
      kind: 'list',
      items: [
        "an error in Klargo's contract flow",
        'an incorrect contract version',
        'an error in a BankID connection Klargo is responsible for',
        'documents Klargo has undertaken to provide but has not delivered',
        'an incorrect charge of a Klargo fee',
        'an agreed feature that does not work',
      ],
    },
    { kind: 'paragraph', text: 'Contact Klargo and describe what went wrong, when it occurred and what resolution you are seeking.' },
    { kind: 'paragraph', text: 'Klargo must be given the opportunity to investigate and, where possible, correct the error within a reasonable time.' },
    { kind: 'paragraph', text: 'Your rights in the event of a defect, delay, price reduction, termination or compensation follow from applicable mandatory consumer law and are not limited by these terms.' },
    { kind: 'paragraph', text: 'Claims or complaints concerning the following must be directed to the other party in the vehicle deal:' },
    {
      kind: 'list',
      items: [
        "the vehicle's condition or function",
        "the seller's vehicle information",
        "the buyer's payment",
        'the handover',
        'a defect or breach of contract under the purchase contract',
      ],
    },
    { kind: 'paragraph', text: "Complaints about the Swedish Transport Agency's or a bank's own service may need to be directed straight to that party." },
    { kind: 'section', text: '15. Permitted use' },
    { kind: 'paragraph', text: 'You may only use Klargo for lawful, genuine vehicle deals.' },
    { kind: 'paragraph', text: 'You may not:' },
    {
      kind: 'list',
      items: [
        'knowingly provide false or misleading information',
        'impersonate someone else',
        "use someone else's account or BankID",
        'use the Service for fraud, money laundering or other criminal activity',
        'attempt to circumvent security features',
        'manipulate, disrupt or overload the Service',
        'introduce malicious code',
        "automatically scrape or mass-collect information without Klargo's permission",
        'use the Service for spam or unsolicited marketing',
      ],
    },
    { kind: 'section', text: '16. Restriction and closure of an account' },
    { kind: 'paragraph', text: 'Klargo may temporarily restrict an account or a deal if there are reasonable grounds to suspect:' },
    {
      kind: 'list',
      items: [
        'unauthorized use',
        'fraud or other criminal activity',
        'a serious breach of these terms',
        'a risk to a user',
        'a risk to Klargo or the security of the Service',
      ],
    },
    { kind: 'paragraph', text: 'The measure must be proportionate to the risk.' },
    { kind: 'paragraph', text: 'Where it can be done without jeopardizing security, an investigation or legal requirements, Klargo will inform the user of the measure and how it can be requested to be reviewed.' },
    { kind: 'paragraph', text: "Klargo will take reasonable account of ongoing deals and the user's access to already signed contracts and documents." },
    { kind: 'paragraph', text: 'You can close your account through the Service or by contacting Klargo.' },
    { kind: 'paragraph', text: 'Closing your account does not affect:' },
    {
      kind: 'list',
      items: [
        'agreements already entered into',
        'signed purchase contracts',
        'payment obligations that have already arisen',
        'ongoing complaints or disputes',
        'information that must be retained under law or for legal claims',
      ],
    },
    { kind: 'section', text: '17. Availability and changes' },
    { kind: 'paragraph', text: 'Klargo works to keep the Service secure and available, but cannot guarantee that it will always work without interruption.' },
    { kind: 'paragraph', text: 'Temporary interruptions may occur due to:' },
    {
      kind: 'list',
      items: [
        'maintenance',
        'updates',
        'security measures',
        'technical errors',
        'disruptions at external services',
        "circumstances beyond Klargo's reasonable control",
      ],
    },
    { kind: 'paragraph', text: 'Klargo may make changes needed for security, legal requirements, technical function or continued development.' },
    { kind: 'paragraph', text: 'As a general rule, an ongoing paid order remains covered by the service, price and terms that applied when the order was placed.' },
    { kind: 'paragraph', text: "If a change materially worsens an already agreed digital service, the user's rights under mandatory consumer law apply." },
    { kind: 'section', text: "18. Klargo's liability" },
    { kind: 'paragraph', text: "Klargo is liable for its own Service in accordance with the agreement and applicable mandatory law." },
    { kind: 'paragraph', text: 'Klargo is not liable for:' },
    {
      kind: 'list',
      items: [
        "the vehicle's condition, value, function or suitability",
        "a user's incorrect or incomplete information",
        'a party failing to pay, hand over the vehicle, or fulfil the purchase contract',
        'disputes between the buyer and the seller',
        'decisions made by the Swedish Transport Agency, banks or other independent parties',
        'errors in external registers that Klargo could not reasonably have detected',
        "circumstances beyond Klargo's reasonable control",
      ],
    },
    { kind: 'paragraph', text: 'Klargo cannot guarantee that the Service prevents all fraud, mistakes or breaches of contract.' },
    { kind: 'paragraph', text: "The involvement of an external provider does not release Klargo from liability for a part of its own Service that Klargo has undertaken to deliver." },
    { kind: 'paragraph', text: 'Nothing in these terms limits any liability or right that cannot be limited under mandatory law.' },
    { kind: 'section', text: '19. Disputes between buyer and seller' },
    { kind: 'paragraph', text: 'Disputes concerning the vehicle, the price, the payment, its condition, the handover, the ownership transfer or the purchase contract must be resolved between the buyer and the seller.' },
    { kind: 'paragraph', text: 'Klargo is not obliged to:' },
    {
      kind: 'list',
      items: [
        'mediate between the parties',
        'determine who is right',
        'pursue a claim on behalf of either party',
        "compensate a party for the other party's breach of contract",
      ],
    },
    { kind: 'paragraph', text: 'Klargo may, where permitted and appropriate, make contracts, timestamps, signing information and other relevant information from the Service available to the affected user or a competent authority.' },
    { kind: 'paragraph', text: 'General information from Klargo is not individual legal advice and does not mean Klargo takes a position in favour of either party.' },
    { kind: 'section', text: '20. Intellectual property, personal data and cookies' },
    { kind: 'paragraph', text: "Klargo and Klargo's licensors own the rights to the Service's software, design, trademarks, text and other content." },
    { kind: 'paragraph', text: 'You are granted a personal, limited and non-transferable right to use the Service in accordance with these terms.' },
    { kind: 'paragraph', text: "You may not copy, sell, license, modify or attempt to reverse-engineer the Service's software, except where permitted by law." },
    { kind: 'paragraph', text: 'This does not limit your right to download and keep your own contracts, receipts and deal documents.' },
    { kind: 'paragraph', text: "Klargo processes personal data in accordance with Klargo's Privacy Policy. Information about cookies and how to manage consents is available in Klargo's cookie settings." },
    { kind: 'section', text: '21. Changes to these terms' },
    { kind: 'paragraph', text: 'Klargo may update these terms where there are legitimate reasons, for example:' },
    {
      kind: 'list',
      items: [
        'changed legislation',
        'security requirements',
        'new or changed features',
        'technical changes',
        'the need for clearer wording',
      ],
    },
    { kind: 'paragraph', text: 'For material changes, Klargo will inform you in advance through the Service or by email.' },
    { kind: 'paragraph', text: 'An already ordered paid service or an ongoing vehicle deal is normally not affected by later changes to these terms.' },
    { kind: 'paragraph', text: 'Klargo may require you to actively accept new terms before starting a new deal or using a new feature.' },
    { kind: 'paragraph', text: 'A normal login does not automatically mean you accept materially changed terms.' },
    { kind: 'section', text: '22. Governing law and dispute resolution' },
    { kind: 'paragraph', text: 'Swedish law applies to these terms, without limiting rights that follow from mandatory consumer legislation.' },
    { kind: 'paragraph', text: "Complaints about Klargo's own Service should first be directed to Klargo, so that we have the opportunity to investigate and address the matter." },
    { kind: 'paragraph', text: "If you and Klargo cannot reach an agreement, a dispute concerning Klargo's own Service may be tried by a Swedish general court." },
    { kind: 'paragraph', text: "As a consumer, you may also have the right to refer the dispute to the National Board for Consumer Disputes (Allmänna reklamationsnämnden, ARN), if the Board's requirements are met." },
    { kind: 'paragraph', text: 'ARN handles disputes between consumers and businesses. A dispute between the buyer and the seller concerning the vehicle itself is a dispute between two private individuals and is not a consumer dispute against Klargo.' },
    { kind: 'section', text: '23. Contact' },
    { kind: 'paragraph', text: "Questions, complaints and claims concerning Klargo's own Service can be submitted to:" },
    { kind: 'paragraph', text: 'Klargo Technologies AB' },
    { kind: 'paragraph', text: 'Company registration number: 559571-7736' },
    { kind: 'paragraph', text: 'Email: info@klargo.se' },
    { kind: 'paragraph', text: 'Where the right of withdrawal applies to a paid Klargo service, you can use the withdrawal function in the Service or submit another clear statement to Klargo.' },
    { kind: 'paragraph', text: "Claims relating to the vehicle, the payment between the buyer and the seller, or a party's obligations under the purchase contract must be directed to the other party in the vehicle deal." },
  ],
};

export function getTermsContent(languageCode) {
  return languageCode === 'en' ? EN : SV;
}

// Back-compat named exports (Swedish) for any other current callers.
export const TERMS_TITLE = SV.title;
export const TERMS_EFFECTIVE = SV.effective;
export const TERMS_UPDATED = SV.updated;
export const TERMS_INTRO = SV.intro;
export const TERMS_BLOCKS = SV.blocks;
